<template>
	<div class="grid grid-cols-6 gap-4">
        <div class="col-span-1 relative hidden md:block">
            <div class="absolute inset-0 overflow-scroll scrollbar-hidden thumbnails">
                <slot name="thumbnails"
                      :active-image="sharedState.activeImage"
                      :set-active-image="setActiveImage"
                ></slot>
            </div>
        </div>

        <div class="col-span-6 md:col-span-5 relative ratio-16:11">
            <slot></slot>
        </div>

        <div class="col-span-6 md:hidden relative h-24">
            <div class="absolute inset-0 overflow-scroll scrollbar-hidden thumbnails-mobile flex items-start">
                <slot name="thumbnails"
                      :active-image="sharedState.activeImage"
                      :set-active-image="setActiveImage"
                ></slot>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
        data() {
            return {
                sharedState: {
                    activeImage: 0,
                }
            }
        },

        provide() {
            return {
                rotatorState: this.sharedState
            }
        },

        methods: {
            setActiveImage(id) {
                this.sharedState.activeImage = id;

                let thumbnail = document.querySelector(`.thumbnails :nth-child(${id + 1})`);
                let thumbnails = document.querySelector(`.thumbnails`);

                let thumbnailMobile = document.querySelector(`.thumbnails-mobile :nth-child(${id + 1})`);
                let thumbnailsMobile = document.querySelector(`.thumbnails-mobile`);

                thumbnails.scrollTo({
                    top: thumbnail.offsetTop,
                    left: 0,
                    behavior: 'smooth'
                });

                thumbnailsMobile.scrollTo({
                    top: 0,
                    left: thumbnailMobile.offsetLeft,
                    behavior: 'smooth'
                })
            }
        }
    }
</script>
